import { render, staticRenderFns } from "./ProjectType.vue?vue&type=template&id=b9aaa6f8&scoped=true"
import script from "./ProjectType.vue?vue&type=script&lang=js"
export * from "./ProjectType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aaa6f8",
  null
  
)

export default component.exports